import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


import shubhamblog from "../../Assets/Projects/shubhamblog.png";
import text_to_html from "../../Assets/Projects/text_to_html.png";
import Derive_app from "../../Assets/Projects/Derive_app.png";
import portfolio_website from "../../Assets/Projects/portfolio_website.png";
import  todo_list from "../../Assets/Projects/todo_list.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Derive_app}
              isBlog={false}
              title="Derive"
              description="Derive finance app which that enables users to keep track
              their individual expenses and create financial objectives for their futures. Our tech stack includes React-native, Expo with typescript as the frontend and 
              SQLite as the local database."
              ghLink="https://github.com/shubhamAW/Derive-personal_Finance_app"
              demoLink="https://expo.dev/@shubhamaw/derive"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio_website}
              isBlog={false}
              title="Portfolio Website"
              description="My personal portfolio website page build with react.js and Css with Multi-page Layout and styled with React-Bootstrap and CSS with easy customize colors with fully reponsiveness "
              ghLink="https://github.com/shubhamAW"
              demoLink="https://github.com/shubhamAW"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shubhamblog}
              isBlog={false}
              title="Personal Blog site"
              description="Personal Blog site created using django framework of python. and frontend consist of HTML and bootstrap-css which is fully reponsive website which powers dynamically add new blog using django-admin and reflect dynamically to frontend part of website."
              ghLink="https://github.com/shubhamAW/Django_blog"
              demoLink="https://youtu.be/v9C616bcj0o"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={text_to_html}
              isBlog={false}
              title="Text-to-HTML converter"
              description="text to HTML converter built using django framework. used ckeditor to provide the normal editing environment like bold, italic , table , font , emoji and others and taking data from ckeditor we convert that data to HTML tags."
              ghLink="https://github.com/shubhamAW/text_to_html"
             // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo_list}
              isBlog={false}
              title="To-DO list app"
              description="A TO-DO list app which built using react-native, contains dynamic animation of completion of todo and implement functionality like right swap to delete todo and animation when to do completes."
              ghLink="https://github.com/shubhamAW"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
